import type { TranscriptionLanguage } from "@/common/types/transcriptionLanguage";
import axiosClient from "@/lib/axios/axiosClient";

export const getTranscriptionLanguages = async (): Promise<
  TranscriptionLanguage[]
> => {
  const response = await axiosClient.get<TranscriptionLanguage[]>(
    "/transcription-languages",
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );

  return response.data;
};
